module.exports = __webpack_public_path__ + "img/Startseite_01.54ece478.png";